import React, { useCallback, useEffect, useState } from "react";
import Styles from './styles.module.scss';
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { forgotPassword, forgotPasswordFailure } from "../../store/main/action";

import logIcon from "../../theme/assets/svg/b_log_icon.svg";

const getErrorText = (error) => {
    if (!error) return null;

    if (Array.isArray(error)) {
        return error[0];
    }

    return error;
};

const ForgotMain = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const formErr = useSelector(store => store.main.forgotPasswordStatusErr);
    const forgotPasswordStatus = useSelector(store => store.main.forgotPasswordStatus);
    const forgotPasswordStatusStarted = useSelector(store => store.main.forgotPasswordStatusStarted);

    const [email, setEmail] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);

    const emailError = getErrorText(formErr?.email);

    const clearFieldError = (fieldName) => {
        if (formErr?.[fieldName]) {
            const updatedErrors = { ...formErr };
            delete updatedErrors[fieldName];

            dispatch(forgotPasswordFailure(updatedErrors));
        }
    };

    const sendFormHandler = useCallback(() => {
        if (!email || forgotPasswordStatusStarted) return;

        setIsSuccess(false);

        dispatch(forgotPassword({ email }));
    }, [email, forgotPasswordStatusStarted, dispatch]);

    useEffect(() => {
        if (forgotPasswordStatus) {
            setIsSuccess(true);
        }
    }, [forgotPasswordStatus]);

    useEffect(() => {
        const onKeyDown = e => {
            if (e.keyCode === 13) {
                sendFormHandler();
            }
        };

        document.addEventListener('keydown', onKeyDown);

        return () => {
            document.removeEventListener('keydown', onKeyDown);
        };
    }, [sendFormHandler]);

    return (
        <section className={Styles.container}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={Styles.formWrap}>
                    <div className={Styles.formTitle}>
                        {t('Восстановление пароля')}
                    </div>

                    <div className={Styles.formSubTitle}>
                        {t('Введите свою почту, чтобы восстановить пароль')}
                    </div>

                    <div className={Styles.contentBox}>
                        <div className={`${Styles.inputWrap} ${emailError ? Styles.inputWrapWithErr : ''}`}>
                            <div className={Styles.inputTitleRow}>
                                <div className={Styles.inputTitle}>
                                    {t('Почта')}
                                </div>
                            </div>

                            <div className={Styles.inputBox}>
                                <input
                                    type="text"
                                    placeholder="example@gmail.com"
                                    value={email}
                                    disabled={forgotPasswordStatusStarted}
                                    onChange={(e) => {
                                        setEmail(e.target.value);
                                        setIsSuccess(false);
                                        clearFieldError('email');
                                    }}
                                />

                                <div className={Styles.absLeft}>
                                    <img src={logIcon} alt={t('Почта')} />
                                </div>
                            </div>

                            <div className={`${Styles.tcErr} ${emailError ? Styles.tcErrActive : ''}`}>
                                {emailError}
                            </div>
                        </div>

                        <div className={`${Styles.successRow} ${isSuccess ? Styles.successRowActive : ''}`}>
                            <div className={Styles.successMsg}>
                                {t('Если такой email зарегистрирован, мы отправили ссылку для восстановления пароля. Проверьте почту.')}
                            </div>
                        </div>
                    </div>

                    <button
                        type="button"
                        className={`${Styles.mainBtn} ${forgotPasswordStatusStarted ? Styles.disabled : ''}`}
                        onClick={sendFormHandler}
                        disabled={forgotPasswordStatusStarted}
                    >
                        {forgotPasswordStatusStarted ? t('Загрузка...') : t('Восстановить пароль')}
                    </button>

                    <div className={Styles.sep} />

                    <div className={Styles.note}>
                        {t('Впервые в NEXT?')}{" "}
                        <span onClick={() => navigate('/sign-up')}>
                            {t('Стать клиентом')}
                        </span>
                    </div>
                </div>

                <div className={Styles.imgWrap} />
            </div>
        </section>
    );
};

export default ForgotMain;